import { useNavigate } from 'react-router-dom';
import img from '../../Images/heros.png'
import useReviews from '../Hook/useReviews';

const Home = () => {
    const [reviews, setReviews] = useReviews();
    const navigate = useNavigate();
    const sliceReview = reviews.slice(0, 3);
    return (
        <main>
            <section className='py-5'>
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <img className='img-fluid' src={img} alt="" />
                    </div>
                    <div className="col-md-6">
                        <h2 className='fs-1 fw-bold text-uppercase'>Flash <small className='fs-1 fw-bold text-warning'>sale</small> </h2>
                        <p className='fs-5 fw-semibold'>A flash sale also called a deal of the day, is a sale with a big discount that can reach up to 80% on particular items and is only valid for a short period, usually for 24-36 hours. It helps your brand draw the attention of buyers, improve conversions, increase sales and revenue, and improve customer loyalty.</p>
                    </div>
                </div>
            </section>
            <section className='py-5'>
                <h1 className='text-center mb-5 fw-bold fs-1'> <small className='fs-1 fw-bold text-warning'>Customer</small> Review </h1>
                <div className="row g-3">
                    {
                        sliceReview.map(review =>
                            <div className='col-lg-4 mt-3'>
                                <div className='shadow-lg p-3 h-100'>
                                    <img src={review.img} className='rounded-circle' width={100} height={100} alt="" />
                                    <h3>{review.name}</h3>
                                    <h4 className='text-warning fs-6 fw-bold'>Ratting: {review.rating}</h4>
                                    <p>{review.body}</p>
                                </div>
                            </div>
                        )
                    }

                </div>
                <div className='mt-5 text-center'>
                    <button onClick={() => navigate('/reviews')} className='btn btn-success w-50'>See all Reviews</button >
                </div>
            </section>
        </main>
    );
};

export default Home;